import { Injectable } from '@angular/core';

import { RestService } from './rest.service';

import { objectToQueryString } from '../../common/utils';

import { environment } from '../../../environments/environment';

@Injectable()
export class LutService {
  constructor(private readonly rest: RestService) {}

  getStates(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/lut/state`);
  }

  getResolutionTypes(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/lut/resolution-type`);
  }

  getResolutionStatuses(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/lut/resolution-status`);
  }
}
